<span class="clipboard-output">{{ clipboardValue }}</span>
<rt-icon *ngIf="icon" [name]="icon" [size]="'small-x'"></rt-icon>
<span class="content-wrapper">
  <span class="prevent-copy" [attr.data-text]="displayValue"></span>
  <ng-content></ng-content>
</span>
<span *ngIf="dropdownOpen !== undefined" class="dropdown-icon"></span>
